// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".harsh-coach-mark {\n  position: absolute;\n  padding: 18px;\n  border: 0px;\n  border-radius: 8px;\n  box-shadow: 0px 0px 0px 3500px rgba(23, 31, 44, 0.6); /* N700 color, 0.7 opacity */\n  z-index: 1000;\n}\n\n.hcm-tooltip-base {\n  position: absolute;\n  background-color: #ffffff;              /* N0 color, 1.0 opacity */\n  border-radius: 16px;\n  padding: 18px;\n  z-index: 1001;\n  max-width: 328px;\n}\n\n.hcm-tooltip-base::before {\n  content: none;\n}\n", ""]);
// Exports
module.exports = exports;
